module.exports = function() {
  return new Worker(__webpack_public_path__ + "d2271be9a67638d3642f.worker.js");
};